/* msd-buscador-barra.js
 *
 * Anade sugerencias de IMPRESORA a la barra de busqueda principal.
 *
 * Por que hace falta: la busqueda de Shopify NO indexa metacampos. Los ~9.700
 * modelos de impresora no son productos, solo datos, asi que su buscador nunca
 * los va a devolver por mucho que se configure. Esta capa va por encima.
 *
 * Convivencia con el tema: predictive-search.js reescribe el interior de
 * [data-predictive-search] en cada consulta. Nuestro bloque vive FUERA de ese
 * contenedor, asi que no se pisan. No se modifica ningun fichero nativo.
 *
 * Criterio de negocio (Gonzalo): si vendemos la impresora, la fila muestra la
 * ficha del catalogo Y el boton de consumibles: dos destinos, una sola fila.
 * Si no la vendemos, sale solo la sugerencia con el boton. Lo que se quiere
 * vender son consumibles, asi que el boton esta SIEMPRE.
 *
 * Si el indice no carga, no pasa nada: la barra sigue funcionando como antes.
 */
(function () {
  'use strict';

  var MAX = 6;            // filas nuestras; por encima tapa los productos
  var MIN = 2;            // caracteres antes de sugerir nada
  var DATOS = null, cargando = false;

  var caja = document.getElementById('msd-imp');
  if (!caja) return;
  var input = document.getElementById('msd-search-input');
  var ps = caja.closest('predictive-search');
  var form = caja.closest('form');
  var panel = form && form.querySelector('[data-predictive-search]');
  if (!input || !form) return;

  var URL_IDX = caja.getAttribute('data-src');

  function norm(s) {
    return (s || '').toString().toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  function clave(s) { return norm(s).replace(/[^a-z0-9]/g, ''); }

  /* Las palabras del nombre, cada una sin separadores. Parte tambien por '/' y parentesis
     porque el indice trae modelos como 'ColorQube 9201/9202/9203'. */
  function toks(s) {
    return norm(s).split(/[\s/,()]+/).map(clave).filter(Boolean);
  }

  /* ¿La referencia tecleada esta en el nombre, EMPEZANDO DONDE EMPIEZA UNA PALABRA?

     Hace falta unir las palabras porque el indice separa lo que el cliente junta: guarda
     'MFC 7460' y el cliente escribe 'mfc-7460' o 'mfc7460'. Pero unirlas a ciegas casaba a
     media palabra: 'c5890' aparecia dentro de 'MF|C 5890|CN' —la c de MFC pegada al numero—
     y buscar una Epson ofrecia una Brother.

     Exigir que el match arranque en el principio de una palabra resuelve las dos cosas:
        'mfc7460' sobre 'mfc|7460'     -> empieza en la 'm' de mfc          SI
        'c5890'   sobre 'mfc|5890cn'   -> empezaria dentro de mfc           NO
        'c5890'   sobre 'wf|c5890dwf'  -> empieza en la 'c' de c5890dwf     SI

     Medido sobre los 8.663 modelos del indice: 348 cruzaban de marca con la regla vieja,
     121 con esta, y los 8.663 se siguen encontrando a si mismos. */
  function casaUnido(s, qk) {
    var ts = toks(s), unido = '', inicios = {}, i;
    for (i = 0; i < ts.length; i++) { inicios[unido.length] = 1; unido += ts[i]; }
    for (i = unido.indexOf(qk); i !== -1; i = unido.indexOf(qk, i + 1)) {
      if (inicios[i]) return true;
    }
    return false;
  }

  function carga() {
    if (DATOS || cargando || !URL_IDX) return;
    cargando = true;
    fetch(URL_IDX)
      .then(function (r) { return r.json(); })
      .then(function (j) { DATOS = j; cargando = false; pinta(); })
      .catch(function () { cargando = false; });   // se queda como estaba
  }

  /* Busqueda por palabras sobre "marca modelo": escribir 'brother j4335' o
     'j4335dw' tiene que llegar al mismo sitio. Se puntua para que lo que
     EMPIEZA por lo escrito salga antes que lo que solo lo contiene. */
  function busca(q) {
    if (!DATOS) return [];
    var pals = norm(q).split(/\s+/).filter(Boolean);
    if (!pals.length) return [];
    var qk = clave(q);
    var out = [];
    for (var i = 0; i < DATOS.m.length; i++) {
      var f = DATOS.m[i];
      var marca = DATOS.marcas[f[0]];
      var texto = norm(marca + ' ' + f[1]);
      var nombre = marca + ' ' + f[1];
      var vale = true;
      for (var p = 0; p < pals.length; p++) {
        if (texto.indexOf(pals[p]) === -1) { vale = false; break; }
      }
      /* RESPALDO PARA QUIEN TECLEA LA REFERENCIA SIN SEPARADORES: 'wfc5890' tiene que
         encontrar 'WF-C5890DWF'. Se compara TOKEN A TOKEN y no contra el nombre entero
         sin espacios, porque eso casaba a caballo entre dos palabras: 'c5890' aparecia
         dentro de 'MFC 5890CN' —la 'c' de MFC pegada al 5890— y buscar una Epson te
         ofrecia una Brother. Con tokens: 348 modelos cruzaban de marca, ahora 24, y
         ninguno deja de encontrarse a si mismo (medido sobre los 8.663 del indice). */
      if (!vale && qk.length >= 4 && casaUnido(nombre, qk)) vale = true;
      if (!vale) continue;
      var punt = 0;
      if (clave(f[1]).indexOf(clave(pals[pals.length - 1])) === 0) punt -= 3;
      if (f[3] >= 0) punt -= 2;          // si la vendemos, arriba
      out.push([punt, f[1].length, f]);
      if (out.length > 400) break;
    }
    out.sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });

    /* Una misma impresora puede estar dos veces en el indice con el nombre de
       familia delante: 'EcoTank ET-2850' y 'ET 2850' son la misma maquina, y
       salian como dos filas. Se quita la familia para comparar y gana la que
       tenga ficha de producto, que por el orden ya viene antes. */
    var vistas = {}, unicas = [];
    for (var k = 0; k < out.length && unicas.length < MAX; k++) {
      var g = out[k][2];
      var kk = g[0] + '|' + clave(f_familia(g[1]));
      if (vistas[kk]) continue;
      vistas[kk] = 1;
      unicas.push(g);
    }
    return unicas;
  }

  var FAMILIA = /^(ecotank pro|ecotank|expression photo hd|expression photo|expression|workforce pro|workforce|smart tank|laserjet pro|laserjet|officejet pro|officejet|deskjet|color laser|maxify|pixma|envy)\s+/i;

  function f_familia(m) {
    var s = (m || '').replace(FAMILIA, '');
    // si al quitar la familia no queda ningun numero, no era una familia:
    // se deja el nombre entero para no fundir modelos distintos
    return /\d/.test(s) ? s : m;
  }

  function enlaceConsumibles(f) {
    var marca = DATOS.marcas[f[0]];
    var u = '/collections/' + (DATOS.col[f[2]] || DATOS.col.t)
          + '?filter.p.m.custom.impresoras=' + encodeURIComponent(f[1]);
    if (marca && marca !== 'Otras') {
      u += '&filter.p.m.custom.marca_compatible=' + encodeURIComponent(marca);
    }
    return u + '&sort_by=price-ascending';
  }

  function esc(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;',
               '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* UN BOTON POR MODELO, TODOS EN LA MISMA LINEA (Gonzalo, 06/09).
     Antes cada impresora que no vendemos ocupaba su propia fila, con el nombre a la
     izquierda, la etiqueta «No disponible» y un boton a la derecha que repetia
     «Consumibles compatibles» tantas veces como modelos casaran. Buscando `mfc-j43`
     salian tres filas casi identicas para decir lo mismo.
     Ahora el texto se dice UNA vez y el modelo va dentro del boton, que es lo unico
     que cambia de uno a otro. La etiqueta «No disponible» se retira: el boton habla de
     consumibles, y que no vendamos la impresora no venia a cuento. */
  function chip(f) {
    var pr = f[3] >= 0 ? DATOS.prod[f[3]] : null;
    var nombre = pr ? pr[1] : (DATOS.marcas[f[0]] + ' ' + f[1]);
    return '<a class="msd-imp__btn msd-imp__btn--3d msd-imp__chip" href="'
         + esc(enlaceConsumibles(f)) + '">' + esc(nombre) + '</a>';
  }

  function fila(f) {
    var marca = DATOS.marcas[f[0]];
    var pr = f[3] >= 0 ? DATOS.prod[f[3]] : null;
    /* SIN NADA QUE COMPRAR, UNA SOLA LINEA. Dos casos acaban aqui: la impresora que no
       tenemos en catalogo y la que si, pero sin existencias. Para el cliente son lo
       mismo —no se la podemos servir hoy— y lo unico util es el camino a sus
       consumibles. Se etiqueta «No disponible» y no «Sin stock» (Gonzalo, 05/09):
       muchas de estas impresoras no las hemos vendido nunca, y «sin stock» daria a
       entender que normalmente las tenemos.
       Antes ocupaban dos alturas con un hueco gris donde deberia ir una
       foto, aparentando una ficha que no existe.
       Toda la linea es UN enlace: asi pinchar en el nombre y pinchar en el boton hacen
       exactamente lo mismo, sin JavaScript que los tenga que mantener sincronizados. */
    if (!pr || !pr[3]) return '';        // estas van al bloque de botones, no aqui
    var h = '<li class="msd-imp__fila">';
    if (pr) {
      h += '<a class="msd-imp__prod" href="/products/' + esc(pr[0]) + '">'
         + (pr[2] ? '<img src="' + esc(pr[2]) + '" alt="" loading="lazy" width="44" height="44">' : '<span class="msd-imp__ph"></span>')
         + '<span class="msd-imp__txt"><strong>' + esc(pr[1]) + '</strong>'
         + '<em>' + esc(marca + ' ' + f[1]) + (pr[3] ? ' &middot; en stock' : '') + '</em></span></a>';
    } else {
      h += '<span class="msd-imp__prod msd-imp__prod--solo">'
         + '<span class="msd-imp__ph"></span>'
         + '<span class="msd-imp__txt"><strong>' + esc(marca + ' ' + f[1]) + '</strong>'
         + '<em>tu impresora</em></span></span>';
    }
    h += '<a class="msd-imp__btn msd-imp__btn--3d" href="' + esc(enlaceConsumibles(f)) + '">'
       + 'Consumibles compatibles</a></li>';
    return h;
  }

  /* SIN DUPLICADOS. La impresora que vendemos salia DOS veces: arriba en «Tu impresora»
     con el boton de consumibles, y otra vez abajo en «Productos» con su precio y su
     stock. Gonzalo, 05/09/2026: que salga una sola vez, y que el boton vaya en la fila
     del producto, que es la que ademas dice el precio y las unidades.

     Se cotejan por HANDLE, que es exacto. Y solo se quita de arriba lo que de verdad
     esta abajo: si la busqueda de Shopify no devolviera esa ficha, la fila de arriba se
     queda. Mas vale repetir una impresora que perderla.

     El boton se cuelga del <li>, no dentro del <a> del producto: un enlace dentro de otro
     no es HTML valido y el navegador lo desmonta. */
  /* handle de la ficha -> primera fila de modelo que la usa, para poder construir el
     enlace a sus consumibles. Se calcula una vez: el indice no cambia en la sesion.
     Si una ficha cubre varios modelos gana el primero, que es el orden del indice. */
  var _mapa = null;
  function mapaFichas() {
    if (_mapa) return _mapa;
    _mapa = {};
    if (!DATOS) return _mapa;
    for (var i = 0; i < DATOS.m.length; i++) {
      var f = DATOS.m[i];
      if (f[3] < 0) continue;
      var h = '/products/' + DATOS.prod[f[3]][0];
      if (!_mapa[h]) _mapa[h] = f;
    }
    return _mapa;
  }

  function reconciliar() {
    var lista = document.querySelector('#predictive-search-results-products-list');
    if (!lista) return;
    var porHandle = {};
    var pl = lista.querySelectorAll(':scope > li');
    for (var i = 0; i < pl.length; i++) {
      var pa = pl[i].querySelector('a[href*="/products/"]');
      if (pa) porHandle[pa.getAttribute('href').split('?')[0]] = pl[i];
    }
    /* EL BOTON VA POR LO QUE ES EL PRODUCTO, NO POR DONDE ESTABA. La primera version
       solo lo ponia a las impresoras que ademas salian arriba en «Tu impresora», y la
       MFC-J5740DW —que vendemos— aparecia en Productos sin boton porque nuestra lista de
       modelos no la habia sacado para esa busqueda. Ahora se mira el handle de CADA fila
       de producto contra el indice: si es una impresora del catalogo, lleva boton. */
    var idx = mapaFichas();
    for (var k = 0; k < pl.length; k++) {
      var pa2 = pl[k].querySelector('a[href*="/products/"]');
      if (!pa2 || pl[k].querySelector('.msd-imp__btn--enprod')) continue;
      var f2 = idx[pa2.getAttribute('href').split('?')[0]];
      if (!f2) continue;
      var nb2 = document.createElement('a');
      nb2.className = 'msd-imp__btn--enprod';
      nb2.href = enlaceConsumibles(f2);
      nb2.textContent = 'Consumibles compatibles';
      pl[k].appendChild(nb2);
    }

    /* SOLO LAS FILAS DE IMPRESORA. Las de tintas (`--tinta`) no se tocan: no son una ficha
       repetida de la lista de abajo, son lo unico que las enseña. */
    var mias = caja.querySelectorAll('.msd-imp__fila:not(.msd-imp__fila--tinta)');
    for (var j = 0; j < mias.length; j++) {
      var a = mias[j].querySelector('a.msd-imp__prod');
      if (!a) continue;                       // fila compacta: no hay ficha que duplicar
      var destino = porHandle[a.getAttribute('href').split('?')[0]];
      if (!destino) continue;                 // no esta abajo: se queda arriba
      var b = mias[j].querySelector('.msd-imp__btn');
      if (b && !destino.querySelector('.msd-imp__btn--enprod')) {
        var nb = document.createElement('a');
        nb.className = 'msd-imp__btn--enprod';
        nb.href = b.getAttribute('href');
        nb.textContent = 'Consumibles compatibles';
        destino.appendChild(nb);
      }
      mias[j].remove();
    }
    /* NO SE OCULTA SI LAS TINTAS VIENEN DE CAMINO (28/09/2026). Esta linea vaciaba la caja
       —y con ella el hueco `data-tintas`— antes de que llegara la respuesta del fetch, asi
       que la previsualizacion no se pintaba nunca: `muestraTintas` ya no encontraba donde.
       Y como era una carrera contra la red, unas veces salia y otras no; escribir, borrar
       con retroceso y volver a escribir daba resultados distintos para la MISMA busqueda,
       porque la segunda vez la lista de Shopify venia de cache y llegaba antes. */
    var hueco = caja.querySelector('[data-tintas]');
    var enCamino = hueco && CACHE[hueco.getAttribute('data-tintas')] === null;
    var conTintas = hueco && hueco.children.length > 0;
    if (!caja.querySelector('.msd-imp__fila, .msd-imp__chip') && !enCamino && !conTintas) {
      oculta();
    } else {
      alto();
    }
  }

  /* El bloque de productos llega despues que el nuestro y se repinta con cada tecla, asi
     que hay que reconciliar cada vez que cambia. El observador no se puede realimentar:
     lo unico que escribe son cosas que el mismo comprueba antes (el boton solo si no
     estaba) y filas que quita, que ya no vuelve a encontrar. */
  var obsProd = new MutationObserver(function () { reconciliar(); });
  document.addEventListener('DOMContentLoaded', function () {
    obsProd.observe(document.body, { childList: true, subtree: true });
  });

  function alto() {
    if (!panel) return;
    var h = caja.hidden ? 0 : caja.offsetHeight;
    panel.style.marginTop = h ? h + 'px' : '';
  }

  /* EL DESPLEGABLE NO PUEDE PASAR DEL BORDE DE LA PANTALLA (Gonzalo, 09/09: "al hacer
     scroll no veo el ultimo articulo de abajo"). El CSS le daba `max-height:70vh`, que
     es una altura fija sin mirar DONDE empieza: medido en una ventana de 800 px, el
     panel arrancaba en 266 y terminaba en 874, o sea 74 px por debajo del borde. Esos
     74 px no se alcanzan ni desplazando dentro del panel, porque lo que se sale es el
     panel entero: el ultimo articulo queda fuera de la pantalla y no hay forma de verlo.

     Se calcula la altura desde su posicion real, cada vez que se abre o se mueve. El
     minimo de 180 px evita que en una ventana muy baja quede una rendija inservible. */
  function ajustaAlto() {
    [document.querySelector('.msd-searchbar__results'), caja].forEach(function (el) {
      if (!el || el.hidden || !el.offsetParent) return;
      var arriba = el.getBoundingClientRect().top;
      el.style.maxHeight = Math.max(180, window.innerHeight - arriba - 12) + 'px';
      el.style.overflowY = 'auto';
    });
  }
  window.addEventListener('resize', ajustaAlto);
  window.addEventListener('scroll', ajustaAlto, { passive: true });
  /* el desplegable de Shopify lo pinta Shopify, asi que se vigila su contenido en vez
     de confiar en que nos avise */
  document.addEventListener('DOMContentLoaded', function () {
    var res = document.querySelector('.msd-searchbar__results');
    if (res) new MutationObserver(ajustaAlto).observe(res, { childList: true, subtree: true });
  });

  function oculta() {
    caja.hidden = true;
    caja.innerHTML = '';
    alto();
  }

  /* LAS TINTAS, A LA VISTA MIENTRAS ESCRIBE (Gonzalo, 28/09/2026: «c5710 o c5890 encuentra
     impresora y compatibles pero no previsualiza mientras escribes las tintas»). Hasta ahora
     el desplegable ofrecia la impresora y un boton: el cliente tenia que pulsar para saber si
     teniamos SUS tintas y a que precio. Ahora se ven, con su foto y su precio.

     De donde salen: la vista `collection.msdcompat` del tema, pedida con los MISMOS filtros
     que el boton. Son 2 KB de JSON; la pagina entera de la coleccion son 300 KB.

     Se pide UNA sola vez por modelo y se guarda en CACHE, porque el cliente sigue tecleando
     y `pinta()` corre en cada letra. */
  var CACHE = {};

  function tintas(f) {
    var u = enlaceConsumibles(f);
    if (CACHE[u] !== undefined) { muestraTintas(u, f); return; }
    CACHE[u] = null;                       // marcado: ya se esta pidiendo
    fetch(u + '&view=msdcompat')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        CACHE[u] = (j && j.items) ? j : { n: 0, items: [] };
        muestraTintas(u, f);
      })
      .catch(function () { CACHE[u] = { n: 0, items: [] }; });
  }

  function muestraTintas(u, f) {
    var j = CACHE[u];
    if (!j || !j.items || !j.items.length) return;
    /* El cliente ha seguido escribiendo y ya no busca esto: no se pinta tarde. */
    var hueco = caja.querySelector('[data-tintas="' + u + '"]');
    if (!hueco) return;
    var n = Math.min(j.items.length, 4);
    var h = '<p class="msd-imp__tit">Para tu ' + esc(DATOS.marcas[f[0]] + ' ' + f[1]) + '</p>'
          + '<ul class="msd-imp__lista">';
    for (var i = 0; i < n; i++) {
      var it = j.items[i];
      h += '<li class="msd-imp__fila msd-imp__fila--tinta">'
         + '<a class="msd-imp__prod" href="/products/' + esc(it.h) + '">'
         + (it.i ? '<img src="' + esc(it.i) + '" alt="" loading="lazy" width="44" height="44">'
                 : '<span class="msd-imp__ph"></span>')
         + '<span class="msd-imp__txt"><strong>' + esc(it.t) + '</strong>'
         + '<em>' + esc(it.p) + (it.s ? ' &middot; en stock' : '') + '</em></span></a></li>';
    }
    h += '</ul>';
    if (j.n > n) {
      h += '<a class="msd-imp__btn msd-imp__btn--3d" href="' + esc(u) + '">'
         + 'Ver los ' + j.n + ' compatibles</a>';
    }
    hueco.innerHTML = h;
    /* Las tintas llegan DESPUES que todo lo demas, y para entonces `reconciliar` ha podido
       dejar la caja oculta por no quedar nada suyo. Si hay tintas, hay algo que enseñar. */
    caja.hidden = false;
    alto();
    ajustaAlto();
  }

  function pinta() {
    var q = (input.value || '').trim();
    if (q.length < MIN) { oculta(); return; }
    if (!DATOS) { carga(); return; }
    var r = busca(q);
    if (!r.length) { oculta(); return; }
    var enVenta = r.filter(function (f) {
      var pr = f[3] >= 0 ? DATOS.prod[f[3]] : null;
      return pr && pr[3];
    });
    var sueltas = r.filter(function (f) {
      var pr = f[3] >= 0 ? DATOS.prod[f[3]] : null;
      return !pr || !pr[3];
    });
    var html = '';
    if (sueltas.length) {
      html += '<div class="msd-imp__chips">'
            + '<span class="msd-imp__chips-tit">Consumibles compatibles:</span>'
            + sueltas.map(chip).join('') + '</div>';
    }
    if (enVenta.length) {
      html += '<p class="msd-imp__tit">Tu impresora</p><ul class="msd-imp__lista">'
            + enVenta.map(fila).join('') + '</ul>';
    }
    /* Hueco para las tintas del modelo que mejor casa: se rellena cuando llegan, y lleva
       la url dentro para que una respuesta tardia no pise una busqueda posterior. */
    var mejor = r[0];
    if (mejor) html += '<div data-tintas="' + esc(enlaceConsumibles(mejor)) + '"></div>';
    caja.innerHTML = html;
    caja.hidden = false;
    /* LAS TINTAS, ANTES DE RECONCILIAR. Si se piden despues, `reconciliar` encuentra el
       hueco vacio y sin marcar como pendiente, da la caja por vacia y la borra —y con ella
       el hueco—, asi que la respuesta ya no tiene donde pintarse. Pidiendolas antes, el
       hueco queda pintado (si la respuesta estaba en cache) o marcado como en camino, y
       `reconciliar` sabe que hay algo que respetar. */
    if (mejor) tintas(mejor);
    alto();
    ajustaAlto();
    reconciliar();
    /* Si Shopify no encuentra productos, el desplegable no se abre solo y
       nuestras sugerencias no se verian. Se abre aqui. */
    if (ps && !ps.hasAttribute('open')) {
      ps.setAttribute('open', true);
      input.setAttribute('aria-expanded', 'true');
    }
  }

  var t = null;
  input.addEventListener('input', function () {
    clearTimeout(t);
    t = setTimeout(pinta, 120);
    carga();
  });
  input.addEventListener('focus', carga);
  form.addEventListener('reset', function () { setTimeout(oculta, 0); });

  /* CUANDO EL TEMA CIERRA EL DESPLEGABLE.
   *
   * Antes cerrabamos siempre con el, y eso se llevaba por delante nuestras sugerencias
   * (Gonzalo, 06/09, buscando `sx23`): salian las dos Epson, y al segundo desaparecian.
   * Medido: a 1,3 s el bloque esta visible con sus dos botones; a 2,3 s Shopify contesta
   * que NO tiene ningun producto para `sx23`, cierra el desplegable, y nos cerraba a
   * nosotros. Justo al reves de lo que interesa: cuando su buscador no encuentra nada
   * es cuando nuestras impresoras son lo unico que le queda al cliente.
   *
   * Ahora solo se cierra si el cliente ha querido cerrar —Escape, o pinchar fuera— o si
   * ya no hay nada nuestro que ensenar. Si el sigue escribiendo en la caja, se reabre.
   */
  var cierreDelCliente = false;
  function hayNuestras() {
    return !!caja.querySelector('.msd-imp__chip, .msd-imp__fila');
  }
  if (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) cierreDelCliente = true;
    });
    input.addEventListener('input', function () { cierreDelCliente = false; });
  }
  document.addEventListener('click', function (e) {
    if (!caja.contains(e.target) && e.target !== input) cierreDelCliente = true;
  }, true);

  if (ps && window.MutationObserver) {
    new MutationObserver(function () {
      if (ps.hasAttribute('open')) return;
      if (cierreDelCliente || caja.hidden || !hayNuestras() ||
          document.activeElement !== input) {
        oculta();
        return;
      }
      ps.setAttribute('open', true);          // lo nuestro sigue en pie: se reabre
      input.setAttribute('aria-expanded', 'true');
    }).observe(ps, { attributes: true, attributeFilter: ['open'] });
  }

  /* ---- la barra pegada debajo de la cabecera ----
   *
   * La barra es `position:sticky`, pero `top:0` la dejaria debajo de la cabecera, que
   * tambien esta pegada. Aqui se mide lo que ocupa la cabecera y se publica en
   * `--msd-alto-cabecera` para que el CSS lo use como tope.
   *
   * Se recalcula al cargar, al cambiar el tamano de la ventana y cuando la cabecera
   * cambia de alto (el aviso de arriba se puede cerrar, y el menu movil la estira).
   */
  (function fijarBarra() {
    var cabecera = document.querySelector('.shopify-section-group-header-group') ||
                   document.querySelector('#shopify-section-header') ||
                   document.querySelector('header');
    if (!cabecera) return;

    function medir() {
      var alto = Math.round(cabecera.getBoundingClientRect().height);
      // si la cabecera no esta pegada arriba, la barra tampoco necesita hueco
      var pegada = getComputedStyle(cabecera).position === 'sticky' ||
                   getComputedStyle(cabecera).position === 'fixed';
      document.documentElement.style.setProperty(
        '--msd-alto-cabecera', (pegada ? alto : 0) + 'px');
    }

    medir();
    window.addEventListener('resize', medir);
    if (window.ResizeObserver) new ResizeObserver(medir).observe(cabecera);
  })();


  /* ---- en las colecciones, lo agotado al final ----
   *
   * Gonzalo, 06/09: "en las colecciones, ordenar por precio y que los no disponibles
   * esten al final". El precio lo resuelve el propio Shopify —cada coleccion queda con
   * su orden por defecto en precio ascendente— y lo que falta es apartar lo agotado,
   * que su ordenacion no contempla porque el inventario nativo esta desactivado.
   *
   * QUE HACE Y QUE NO: mueve al final de la rejilla las fichas marcadas `msd-stock--no`.
   * Las de encargo (8 a 15 dias) NO se mueven: se pueden comprar, y su sitio es el que
   * le toque por precio.
   *
   * EL LIMITE, que conviene tener claro: esto reordena LO QUE YA ESTA EN LA PAGINA. Si
   * una coleccion tiene tres paginas, lo agotado de la primera baja al final de la
   * primera, no a la tercera. Para eso haria falta filtrar en el servidor, y eso cambia
   * la URL —con lo que Google indexaria la version filtrada—, asi que no se hace aqui.
   */
  (function agotadoAlFinal() {
    if (location.pathname.indexOf('/collections/') !== 0) return;

    function reordenar() {
      var rejilla = document.querySelector('#product-grid');
      if (!rejilla) return;
      var fichas = Array.prototype.slice.call(rejilla.children);
      var agotadas = fichas.filter(function (li) {
        return li.querySelector('.msd-stock--no');
      });
      if (!agotadas.length || agotadas.length === fichas.length) return;
      // si ya estan todas al final, no se toca el DOM
      var cola = fichas.slice(fichas.length - agotadas.length);
      var yaEsta = cola.every(function (li) { return agotadas.indexOf(li) !== -1; });
      if (yaEsta) return;
      var frag = document.createDocumentFragment();
      agotadas.forEach(function (li) { frag.appendChild(li); });
      rejilla.appendChild(frag);
    }

    function listo() {
      reordenar();
      // le dice al snippet que ya puede ensenar la rejilla
      window.dispatchEvent(new Event('msd:orden-listo'));
    }

    document.addEventListener('DOMContentLoaded', listo);
    if (document.readyState !== 'loading') listo();
    // la rejilla se repinta al filtrar o paginar sin recargar
    if (window.MutationObserver) {
      var rej = document.querySelector('#product-grid');
      if (rej) new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length) { reordenar(); return; }
        }
      }).observe(rej, { childList: true });
    }
  })();

})();
